import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/mini-loading.gif'


const _hoisted_1 = { class: "app-connection flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Connect Apps", -1)
const _hoisted_4 = { class: "py-4 flex" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Connected Apps", -1)
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = {
  key: 0,
  class: "h-30"
}
const _hoisted_12 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "h-5 mr-3",
  src: _imports_0,
  alt: "loading..."
}
const _hoisted_15 = {
  key: 0,
  class: "h-5 mr-3 w-5"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-md text-black mb-2" }, [
  /*#__PURE__*/_createTextVNode(" If you click on this link, you will leave MicroSoft Teams and go to another site. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" PS: After connecting successfully, please click on this tab's My Account button, logout and log back in. ")
], -1)
const _hoisted_18 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalContainer = _resolveComponent("ModalContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.disconnectedApps.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disconnectedApps, (app) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ml-3",
                  key: app.name
                }, [
                  (!_ctx.msAppLoaded)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: app.connectionLink
                      }, [
                        _createElementVNode("img", {
                          src: app.addImageSrc,
                          alt: app.name,
                          class: _normalizeClass(app.customCSSClasses)
                        }, null, 10, _hoisted_6)
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_ctx.msAppLoaded && app.id == 'ms-teams')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: app.addImageSrc,
                          alt: app.name,
                          class: _normalizeClass(app.customCSSClasses)
                        }, null, 10, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.connectedApps.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectedApps, (app) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "py-4",
                    key: app.name
                  }, [
                    ((_ctx.msAppLoaded && app.id == 'ms-teams') || !_ctx.msAppLoaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(app.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectedApps, (app) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "py-3",
                    key: app.name
                  }, [
                    ((_ctx.msAppLoaded && app.id == 'ms-teams') || !_ctx.msAppLoaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", {
                            class: "disconnect-btn cursor-pointer",
                            onClick: () => _ctx.disconnectApp(app.id),
                            title: "Uninstall bot & disconnect app"
                          }, " disconnect ", 8, _hoisted_13),
                          _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                            [_vShow, _ctx.loaderId == app.id]
                          ]),
                          (_ctx.loaderId != app.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                            : _createCommentVNode("", true),
                          (_ctx.statusMessage[app.id])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.statusMessage[app.id]), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_ModalContainer, {
          key: 0,
          openImmediately: true,
          onClosed: _ctx.modalClosed
        }, {
          modalTitle: _withCtx(() => [
            _createTextVNode("Connect Teams")
          ]),
          modalContent: _withCtx(() => [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false)),
                class: "text-md text-red-600 mb-2"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.connectTeamsClicked && _ctx.connectTeamsClicked(...args))),
                class: "bg-teal rounded px-2 py-2"
              }, " Accept & Continue ")
            ])
          ]),
          _: 1
        }, 8, ["onClosed"]))
      : _createCommentVNode("", true)
  ], 64))
}